import { luscinia } from "./luscinia";

luscinia.bindPostValueChanged = function (form, filter = null) {
    if (filter === null) {
        filter = form;
    }
    // Add change event to specified input fields
    $(filter).find("[data-" + luscinia.data.postValueChanged + "]").on("change", function () {
        let name = $(this).attr("name") as string;
        var isEditGridProperty = $(`[name='${name}']`).closest(".editGrid-wrapper").length > 0;
        luscinia.executePostValueChange(form, $(this).data(luscinia.data.propertyModulePath), name, ChangeType.Update, isEditGridProperty ? ChangeElement.EditGridProperty : ChangeElement.Property);
    });
};

luscinia.executePostValueChange = function (form, propertyModulePath, name, changeType: ChangeType, changeElement: ChangeElement = ChangeElement.Property, initialTrigger = false, changedValue:object = null) {
    if (form == undefined || form == null)
    {
        form = luscinia.getActiveForm();
    }
    var formData = luscinia.serializeFormObject(form);
    var postValueChangeConfig = getPostValueChangeConfig(form, formData, name, propertyModulePath, changeType, changeElement, changedValue);

    if (postValueChangeConfig.name === undefined) {
        return;
    }

    $.ajax({
        method: "POST",
        cache: false,
        contentType: false,
        processData: false,
        url: postValueChangeConfig.modulePath + "/valuechanged/" + postValueChangeConfig.name,
        data: postValueChangeConfig.formData
    }).done(function (actions) {
        luscinia.executeActionList(actions, form, initialTrigger);
    });
};

export function getPostValueChangeConfig(form: any, formData: FormData, name: string, propertyModulePath: string, changeType: ChangeType, changeElement: ChangeElement, changedValue: object = null): PostValueChangeConfig {
    var postValueChangeConfig = new PostValueChangeConfig();

    postValueChangeConfig.formData = formData;

    if (changeElement == ChangeElement.EditGridProperty) {
        var splitName = name.split('-');
        var parameterPropertyName = splitName[1];
        var propertyName = splitName[3];
        var rowNumber = splitName[2];
        formData.append(`parameter-${parameterPropertyName}-aftervaluechanged-property-name`, propertyName);
        formData.append(`parameter-${parameterPropertyName}-aftervaluechanged-property-value`, luscinia.getLocalizedElementValue($(`[name='${name}']`)));
        formData.append(`parameter-${parameterPropertyName}-aftervaluechanged-rownumber`, rowNumber);
        formData.append(`parameter-${parameterPropertyName}-aftervaluechanged-changetype`, changeType);

        postValueChangeConfig.modulePath = form.data(luscinia.data.modulePath) as string;
        postValueChangeConfig.name = parameterPropertyName;
    }
    else if (changeElement == ChangeElement.EditGridRow) {
        var splitName = name.split('-');
        var parameterPropertyName = splitName[1];
        var rowNumber = splitName[2];
        formData.append(`parameter-${parameterPropertyName}-aftervaluechanged-property-name`, 'row');
        formData.append(`parameter-${parameterPropertyName}-aftervaluechanged-property-value`, JSON.stringify(changedValue));
        formData.append(`parameter-${parameterPropertyName}-aftervaluechanged-rownumber`, rowNumber);
        formData.append(`parameter-${parameterPropertyName}-aftervaluechanged-changetype`, changeType);

        postValueChangeConfig.modulePath = form.data(luscinia.data.modulePath) as string;
        postValueChangeConfig.name = parameterPropertyName;
    }
    else {
        postValueChangeConfig.modulePath = propertyModulePath ? propertyModulePath : form.data(luscinia.data.modulePath) as string;
        postValueChangeConfig.name = name;
    }

    return postValueChangeConfig;
}

class PostValueChangeConfig {
    public modulePath: string;
    public name: string;
    public formData: FormData;
    public changeType: ChangeType;
}


export enum ChangeType {
    Create = "Create",
    Copy = "Copy",
    Update = "Update",
    Delete = "Delete",
    Action = "Action"
};

export enum ChangeElement {
    Property,
    EditGridProperty,
    EditGridRow
};